import { TRIP_STATUS } from '@packages/types';

import { Container } from '@components/container';
import { Button } from '@elements/button';
import { Text } from '@elements/text';
import { i18n } from '@i18n';
import { useModalStore } from '@store';
import { useTripStore } from '@store/trip';
import { testProps } from '@utils';

import AlertIcon from './alert.svg';
import HandsIcon from './hands.svg';

export const ConfirmationBanner = () => {
  const tripStatus = useTripStore(state => state.trip.state);
  const isPaid = tripStatus === TRIP_STATUS.PAID;
  const openModal = useModalStore(state => state.openModal);
  const closeModal = useModalStore(state => state.closeModal);
  const tripBannerImage = useTripStore(state => state.trip.destinations[0]?.imageLinks?.tablet);
  const openPolicyDetailsModal = () => {
    openModal('Modal', {
      body: { type: 'PolicyDetails', isModal: true },
      bodyContainerClassName: 'mt-0 pt-2 px-4 pb-4',
      size: 'lg',
      ImageTitle: (
        <div className="relative">
          <img
            src={tripBannerImage}
            className="h-52 w-full lg:h-72  object-cover rounded-t-br/md"
            alt="Freely logo"
          />
          <Button
            {...testProps('policy-details-modal-close-button')}
            className="absolute top-4 right-4"
            icon="close"
            variant="primary"
            size="sm"
            onClick={closeModal}
          />
        </div>
      ),
      showCloseButton: false,
    });
  };

  if (isPaid) {
    return (
      <div className="bg-surface-success">
        <Container className="flex  gap-s16">
          <HandsIcon className="min-w-14" />
          <div className="space-y-s8">
            <Text {...testProps('confirmation-headerBanner-paid-title')} variant={'h2-36/freely'}>
              {i18n.t('confirmation.headerBanner.paid.title')}
            </Text>
            <Text
              {...testProps('confirmation-headerBanner-paid-subtitle')}
              variant={'subTitle-20/sb'}>
              {i18n.t('confirmation.headerBanner.paid.subtitle')}
            </Text>
            <button
              {...testProps('confirmation-headerBanner-cta')}
              className="text-body lg:hidden underline"
              onClick={openPolicyDetailsModal}>
              {i18n.t('confirmation.headerBanner.cta')}
            </button>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="bg-surface-warning">
      <Container className="flex  gap-s16">
        <AlertIcon className="min-w-14" />
        <div className="space-y-s8">
          <Text {...testProps('confirmation-headerBanner-pending-title')} variant={'h2-36/freely'}>
            {i18n.t('confirmation.headerBanner.pending.title')}
          </Text>
          <Text
            {...testProps('confirmation-headerBanner-pending-subtitle')}
            variant={'subTitle-20/sb'}>
            {i18n.t('confirmation.headerBanner.pending.subtitle')}
          </Text>
          <button
            {...testProps('confirmation-headerBanner-cta')}
            className="text-body lg:hidden underline"
            onClick={openPolicyDetailsModal}>
            {i18n.t('confirmation.headerBanner.cta')}
          </button>
        </div>
      </Container>
    </div>
  );
};
